import { motion } from "framer-motion";
import { UserCheck, TrendingUp, Zap, DollarSign, MessagesSquare, Layers, Quote } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const ICONS = [UserCheck, TrendingUp, Zap, DollarSign, MessagesSquare, Layers];

export default function WhyChoose() {
  const { t } = useLanguage();
  const q = t.why.quote;
  return (
    <section id="why-us" data-testid="why-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5 lg:sticky lg:top-28"
          >
            <div className="text-gold text-sm uppercase tracking-[0.3em] font-semibold mb-4">{t.why.eyebrow}</div>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-[0.95] break-words">
              {t.why.headingLine1}
              <br />
              <span className="text-gold">{t.why.headingLine2}</span>
            </h2>

            <div className="mt-10 relative bg-ink-card border-l-4 border-gold rounded-lg p-8">
              <Quote className="text-gold/30 absolute top-4 right-4" size={48} />
              <p className="font-heading text-2xl md:text-3xl text-white leading-tight">
                {q[0]}
                <span className="text-gold">{q[1]}</span>
                {q[2]}
                <span className="text-gold">{q[3]}</span>
                {q[4]}
                <span className="text-gold">{q[5]}</span>
                {q[6]}
              </p>
            </div>
          </motion.div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
            {t.why.differentiators.map((d, i) => {
              const Icon = ICONS[i] || UserCheck;
              return (
                <motion.div
                  key={d.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="bg-ink-soft/60 rounded-lg p-6 border border-ink-line hover:border-gold/50 transition-colors"
                >
                  <div className="w-10 h-10 rounded bg-gold/10 flex items-center justify-center text-gold mb-4">
                    <Icon size={20} />
                  </div>
                  <h3 className="font-heading text-xl text-white uppercase tracking-wide">{d.title}</h3>
                  <p className="mt-2 text-white/60 text-sm leading-relaxed">{d.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
